import { HttpErrorService } from '@/services/HttpError.service'
import { paymentErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'
import type { Payment } from '@/models'

export class PaymentService {
  private httpErrorService: HttpErrorService<keyof typeof paymentErrorHandbook>
  private endpoint = '/payments'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      paymentErrorHandbook,
      'payment',
    )
  }

  async getByOrderId(orderId: number | undefined, accessCode: number) {
    const url = [this.endpoint, 'process'].join('/')

    return await this.httpService
      .get<Payment>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
        fetchConfig: {
          params: {
            orderId,
            accessCode,
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
